import { render, staticRenderFns } from "./CaseConfigEmails.vue?vue&type=template&id=267f38cc"
import script from "./CaseConfigEmails.vue?vue&type=script&lang=js"
export * from "./CaseConfigEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports